(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nf-fb20-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const configNode = document.getElementById('nf-fb20-config');
      if (!configNode) return;
      const config = JSON.parse(configNode.textContent);
      config.root = config.root.endsWith('/') ? config.root : config.root + '/';
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: config.currency }).format(cents / 100);
      const panels = () => document.querySelectorAll('[data-nf-fb20-cart]');
      const message = (heading, detail, state) => panels().forEach((panel) => {
        panel.dataset.state = state;
        panel.querySelector('[data-nf-fb20-status]').textContent = heading;
        panel.querySelector('[data-nf-fb20-message]').textContent = detail;
      });
      const display = (cart) => {
        if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) return;
        const allocations = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap((item) => (item.line_level_discount_allocations || []).map((entry) => ({ ...entry.discount_application, total_allocated_amount: entry.amount })))];
        const matching = allocations.filter((entry) => String(entry.title || '').toUpperCase() === 'FB20');
        const saved = matching.reduce((sum, entry) => sum + Number(entry.total_allocated_amount || 0), 0);
        document.querySelectorAll('[data-nf-fb20-total]').forEach((node) => { node.textContent = money(cart.total_price); });
        document.querySelectorAll('[data-nf-fb20-subtotal]').forEach((node) => { node.textContent = money(cart.original_total_price); });
        const allSavings = cart.original_total_price - cart.total_price;
        document.querySelectorAll('[data-nf-fb20-discount-row]').forEach((node) => { node.hidden = !(allSavings > 0); });
        document.querySelectorAll('[data-nf-fb20-savings]').forEach((node) => { node.textContent = '−' + money(allSavings); });
        document.querySelectorAll('[data-nf-fb20-discount-label]').forEach((node) => { node.textContent = saved > 0 ? 'FB20' : config.other_discount; });
        if (saved > 0) message(config.applied, config.saved.replace('[amount]', money(saved)), 'applied');
        else message(config.pending, config.eligibility, 'pending');
      };
      let inFlight;
      const apply = () => {
        if (inFlight) return inFlight;
        message(config.applying, config.eligibility, 'loading');
        inFlight = fetch(config.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ discount: 'FB20' })
        }).then((response) => { if (!response.ok) throw new Error('Discount request failed'); return response.json(); })
          .then((cart) => { if (cart.errors || !Array.isArray(cart.items)) throw new Error('Invalid cart response'); display(cart); return cart; })
          .catch(() => { message(config.unavailable, config.retry, 'error'); return null; })
          .finally(() => { inFlight = null; });
        return inFlight;
      };
      window.NF20Offer = { apply, display };
      if (panels().length && config.count > 0) apply();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => { if (panels().length) return apply(); });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ninety-eight-collection-smart-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const refreshLinks = (root) => {
    const current = new URL(window.location.href);
    root.querySelectorAll('[data-nf-filter-action]').forEach((link) => {
      const target = new URL(link.href, current);
      const params = new URLSearchParams(current.search);
      const action = link.dataset.nfFilterAction;
      params.delete('page');
      params.delete('section_id');
      params.delete('sections');
      if (action === 'clear') {
        [...params.keys()].filter((key) => key.startsWith('filter.')).forEach((key) => params.delete(key));
      } else if (action === 'price') {
        params.delete(root.dataset.priceMinParam);
        params.delete(root.dataset.priceMaxParam);
        if (link.dataset.priceMin) params.set(root.dataset.priceMinParam, link.dataset.priceMin);
        if (link.dataset.priceMax) params.set(root.dataset.priceMaxParam, link.dataset.priceMax);
      } else if (action === 'sort') {
        params.set('sort_by', link.dataset.sortBy);
      } else if (action === 'remove-value') {
        const name = link.dataset.filterParam;
        const remaining = params.getAll(name).filter((value) => value !== link.dataset.filterValue);
        params.delete(name);
        remaining.forEach((value) => params.append(name, value));
      }
      target.search = params.toString();
      target.hash = 'nf-collection-filters';
      link.href = target.toString();
    });
  };
  const initialize = () => {
    document.querySelectorAll('[data-nf-smart-filters]').forEach((root) => {
      refreshLinks(root);
      if (root.dataset.nfInitialized) return;
      root.dataset.nfInitialized = 'true';
      const options = root.querySelector('.nf-smart-filters__options');
      const mobile = window.matchMedia('(max-width: 749px)');
      options.open = !mobile.matches;
      mobile.addEventListener('change', () => { options.open = !mobile.matches; });
      root.addEventListener('click', () => refreshLinks(root));
      document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a');
        if (!link) return;
        const destination = new URL(link.href, window.location.href);
        if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash === '#nf-collection-filters') options.open = true;
      });
      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#nf-collection-filters') options.open = true;
      });
      if (window.location.hash === '#nf-collection-filters') options.open = true;
    });
  };
  initialize();
  window.addEventListener('pageshow', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
